import { post } from './fetch';

const apiOrderWasSeen = async ( orderId, setOrder, dispatch ) => {
    await post( 'apiOrderWasSeen', '/api/order/was-seen',
        { orderId }, setOrder, dispatch
    );
}

export default apiOrderWasSeen;
